var window=global;var $CLJS=require("./cljs_env");require("./goog.base.js");require("./goog.useragent.useragent.js");require("./goog.html.safehtml.js");
(0,$CLJS.ha)();